// extracted by mini-css-extract-plugin
export default {"checkList":"TodoList_checkList__x-zY5","checkInput":"TodoList_checkInput__wPGD2","edit":"TodoList_edit__Eb1OL"};